import { Card } from './card'
import { CardSuite } from '../types/card-suite'

export class CardArray extends Array<Card> {
  static override from(input: Card[]): CardArray {
    return new CardArray(input)
  }

  private constructor(input: Card[] | number) {
    if (typeof input === 'number') {
      super(input)
      return
    }

    super(input.length)

    input.forEach((element, index) => {
      this[index] = element
    })
  }

  public override filter(
    predicate: (value: Card, index: number, array: Card[]) => unknown,
    thisArg?: any,
  ): CardArray {
    const filteredArray = super.filter(predicate, thisArg)
    return new CardArray(filteredArray)
  }

  public override forEach(
    callbackfn: (value: Card, index: number, array: Card[]) => void,
    thisArg?: any,
  ): void {
    super.forEach(callbackfn, thisArg)
  }

  public sortCards(): CardArray {
    if (this.containsFourSuites()) {
      return this.sort(Card.rankComparer).sort(Card.fourSuiteComparer)
    }

    if (this.containsThreeSuites() && !this.containsSuite('Spades')) {
      return this.sort(Card.rankComparer).sort(Card.threeSuiteComparerNoSpades)
    }

    if (this.containsThreeSuites() && !this.containsSuite('Hearts')) {
      return this.sort(Card.rankComparer).sort(Card.threeSuiteComparerNoHearts)
    }

    return this.sort(Card.rankComparer).sort(Card.fourSuiteComparer)
  }

  public contains(card: Card): boolean {
    return (
      super.find(
        (item) => item.rank == card.rank && item.suite == card.suite,
      ) !== undefined
    )
  }

  private containsFourSuites(): boolean {
    return (
      this.containsSuite('Spades') &&
      this.containsSuite('Diamonds') &&
      this.containsSuite('Hearts') &&
      this.containsSuite('Clubs')
    )
  }

  private containsThreeSuites(): boolean {
    return (
      (this.containsSuite('Spades') &&
        this.containsSuite('Diamonds') &&
        this.containsSuite('Hearts')) ||
      (this.containsSuite('Spades') &&
        this.containsSuite('Diamonds') &&
        this.containsSuite('Clubs')) ||
      (this.containsSuite('Spades') &&
        this.containsSuite('Hearts') &&
        this.containsSuite('Clubs')) ||
      (this.containsSuite('Diamonds') &&
        this.containsSuite('Hearts') &&
        this.containsSuite('Clubs'))
    )
  }

  private containsSuite(suite: CardSuite): boolean {
    return this.find((card) => card.suite === suite) !== undefined
  }
}
